// Add your JS customizations here
jQuery(document).ready(function($) { 
		function muteAudio() {

	    var audioStatus = $("#vi-video-1-container").attr('data-audio-volume');

		if (audioStatus == 0) {
		  	// Mute the audio
		  	$('#vi-video-1-container').attr('data-audio-volume', 1);
		  	$("#vi-banner-video").vimeo("setVolume", 1);
		 	$(".audio-control.js-audio-control").removeClass('muted').addClass('unmuted');
		}
		else if (audioStatus == 1){
		  	// Play the audio
		 	$('#vi-video-1-container').attr('data-audio-volume', 0);
		  	$("#vi-banner-video").vimeo("setVolume", 0);
		  	$(".audio-control.js-audio-control").removeClass('unmuted').addClass('muted');
		}
	}

	function playVideo() {
	    // var videoId = el.data('video');
	    // var video = document.getElementById(videoId);
	    var videoStatus = $("#vi-video-1-container").attr('data-video-is-playing');
	     
	    if (videoStatus == 'true') {
	        // Pause the video
	       	console.log('trigger to false');
	        $('#vi-banner-video').vimeo('pause');
	        $('#vi-video-1-container').attr('data-video-is-playing', false);
	    }
	    else if (videoStatus == 'false'){
	        // Play the video
	        console.log('trigger to true');
	        $('#vi-banner-video').vimeo('play');
	        $('#vi-video-1-container').attr('data-video-is-playing', true);
	    }
	}

	if ($('.page-template-home').length > 0) {

		$('.js-audio-control').click(function(event) {
			event.preventDefault();
			muteAudio($(this));
			$(this).toggleClass('audio_on');
		});

		
	    // initial setup
	    // - audio muted/unmuted 
	    var isAudioMuted = true;
	    var isVideoAutoplay = true;


	    if ( isVideoAutoplay === true ){
	      	$('#vi-video-1-container').attr('data-video-is-playing', true);
	      	$('#vi-banner-video').vimeo('play');
	 
	    } else {
	      	$('#vi-video-1-container').attr('data-video-is-playing', false);
	      	$('#vi-banner-video').vimeo('pause');
	    }

	    if ( isAudioMuted === true ){
	     	$('#vi-video-1-container').attr('data-audio-volume', 0);
	      	$("#vi-banner-video").vimeo("setVolume", 0);
	      	$(".audio-control.js-audio-control").removeClass('unmuted').addClass('muted');
	    } else {
	      	$('#vi-video-1-container').attr('data-audio-volume', 1);
	      	$("#vi-banner-video").vimeo("setVolume", 1);
	    }

	    $(window).scroll(function() {

		    var scroll = $(window).scrollTop(),
			target = $('#vi-video-1-container').outerHeight();
			//console.log(target);

			if (scroll >= (target)){
				
			  	$('#vi-banner-video').vimeo('pause');
			  	//console.log('pause');
		        
			}else{

			  	$('#vi-banner-video').vimeo('play');
			  	//console.log('play');
			}
		});
		
	}

	$('#as_seen_images').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: false,
		asNavFor: $('#as_seen_text'),
		fade: true,
	});
	$('#as_seen_text').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: false,
		asNavFor: $('#as_seen_images'),
		fade: true,
	});
	$('#as_seen_logos a').click(function(event) {
		event.preventDefault();
		$('#as_seen_logos a').removeClass('active');
		var slide = $(this).data('slide');
		$('#as_seen_images').slick('slickGoTo', slide);
		$(this).addClass('active');
	});
	$('#as_seen_table a').click(function(event) {
		event.preventDefault();
		$('#as_seen_table a').removeClass('active');
		var slide = $(this).data('slide');
		$('#as_seen_images').slick('slickGoTo', slide);
		$(this).addClass('active');
	});
	$('#gallery_slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		dots: false,
		fade: true,
		prevArrow: $('#smile_prev'),
		nextArrow: $('#smile_next'),
	});
	$('#testimonials_slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 5000,
	});

	$('#main-menu .hasSub a').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		
		
		if($(this).hasClass('active')) {
			$('#main-nav .navbar-nav .nav-item.current-menu-item .nav-link').css('color','');
			$(this).removeClass('active');
			$('body').removeClass('modal-open');
			$('.sub_overlay').removeClass('active');
			$(target).removeClass('active');
			
		} else {
			$('#main-nav .navbar-nav .nav-item.current-menu-item .nav-link').css('color','#1b1b1b');
			$('#main-menu .hasSub a').removeClass('active');
			$('.sub_menu').removeClass('active');
			$(this).addClass('active');
			$('body').addClass('modal-open');
			if($('.sub_overlay').hasClass('active')) {
			} else {
				$('.sub_overlay').addClass('active');
			}
			$(target).addClass('active');
		}
		//$(this).toggleClass('active');
		//$('body').addClass('modal-open');
		
		//$(target).toggleClass('active');
		//$('.sub_overlay').toggleClass('active');
	});

	$('.close_menu').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		$(target).removeClass('active');
		$('#main-nav .navbar-nav .nav-item .nav-link').removeClass('active');
		$('body').removeClass('modal-open');
		$('#main-nav .navbar-nav .nav-item.current-menu-item .nav-link').css('color','');
		$('.sub_overlay').removeClass('active');
	});

	$('#mobile_menu .hasSub a').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$('body').removeClass('modal-open');
			$(target).removeClass('active');
		} else {
			$('#mobile_menu .hasSub a').removeClass('active');
			$('.sub_menu').removeClass('active');
			$(this).addClass('active');
			$('body').addClass('modal-open');
			$(target).addClass('active');
		}
		//$(this).toggleClass('active');
		//$('body').addClass('modal-open');
		
		//$(target).toggleClass('active');
		//$('.sub_overlay').toggleClass('active');
	});

	$('.navbar-toggler').click(function() {
		$(this).toggleClass('is-active');
		$('#mobile_menu').toggleClass('active');
		$('body').toggleClass('modal-open');
		$('#mobile_menu_primary .nav-link').removeClass('active');
		$('.sub_menu').removeClass('active');
	});

	$('.close_sub').click(function() {
		var target = $(this).data('target');
		$(target).removeClass('active');
		$('#mobile_menu_primary .nav-link').removeClass('active');
	});

	$('#treatments .section').click(function(event) {
		event.preventDefault();
		$('.navbar-toggler').addClass('is-active');
		$('#mobile_menu').addClass('active');
		var target = $(this).attr('href');
		var menu = $(this).data('menu');
		$('body').addClass('modal-open');
		$('.sub_overlay').addClass('active');
		$(target).addClass('active');
		$(menu).children('a').addClass('active');
	});

	$('.view_treatments').click(function(event) {
		event.preventDefault();
		$('.navbar-toggler').addClass('is-active');
		var target = $(this).attr('href');
		var menu = $(this).data('menu');
		$('body').addClass('modal-open');
		$('.sub_overlay').addClass('active');
		$(target).addClass('active');
		$(menu).children('a').addClass('active');
		$('#main-nav .navbar-nav .nav-item.current-menu-item .nav-link').css('color','#1d1d1b');
	});

	$('#videos_carousel').slick({
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		dots: false,
		arrows: false,
	});		

	$('.video_launch').click(function() {
		var src = $(this).data('video');
		var type = $(this).data('type');
		$('#video_modal iframe').attr('src',src);
		$('#video_modal iframe').addClass(type);
	});

	$('#video_modal').on('hidden.bs.modal', function (e) {
		$('#video_modal .ratio iframe').attr('src','');
		$('#video_modal .ratio iframe').removeClass('.vimeo').removeClass('youtube');
	});

	$('#gallery_nav button').click(function() {
		$('#gallery_nav button').not(this).removeClass('active');
		$('#gallery_nav button').not(this).attr('aria-selected',false);
	});

	$('#gallery_nav_mobile .form-select').on('change', function() {
		var optionSelected = $("option:selected", this);
		var valueSelected = this.value;
		$('.tab-pane').removeClass('show').removeClass('active');
		$(valueSelected).addClass('show').addClass('active');
	});

	$('.pagination .prev').parent().addClass('me-auto d-none d-lg-inline-block');
	$('.pagination .next').parent().addClass('ms-auto d-none d-lg-inline-block');

	$('#awards_home_desktop').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 4000,
	});

	$('#awards_home_mobile').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 4000,
	});

	$('#patient_stories_carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: true,
		prevArrow: $('#video_prev'),
		nextArrow: $('#video_next'),
		fade: false,
		responsive: [
		    {
		      	breakpoint: 769,
		     	settings: {
		        	slidesToShow: 1,
		        	slidesToScroll: 1,
		      	}
		    },
		]
	});

	$('#signature_before_afters_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: true,
		prevArrow: $('#sigba_prev'),
		nextArrow: $('#sigba_next'),
		fade: true,
	});

	$('#patient_testimonials_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: true,
		prevArrow: $('#sigtest_prev'),
		nextArrow: $('#sigtest_next'),
		fade: true,
		autoplay: true,
	});

});
